import { ACTION_AUTH, ACTION_CLEAR_AUTH, SET_ACCOUNT_TYPE } from '../constants/actions';

export function AuthUser(token: string) {
  return {
    payload: { token },
    type: ACTION_AUTH
  };
}

export function SetUserAccountType(params: Partial<AuthReducer.IState>) {
  return {
    payload: params,
    type: SET_ACCOUNT_TYPE
  };
}

export function ClearAuth() {
  return {
    payload: {},
    type: ACTION_CLEAR_AUTH
  };
}
